
module SystemConstants {
    export var Action = {
        MESSAGE_DISPLAY: "MESSAGE_DISPLAY",
        MESSAGE_REMOVE: "MESSAGE_REMOVE",
        ACTION_IN_PROGRESS: "ACTION_IN_PROGRESS",
        ACTION_COMPLETED: "ACTION_COMPLETED",
        MESSAGE_CLEAR_ALL: "MESSAGE_CLEAR_ALL",
        DISPLAY_PRINT: "DISPLAY_PRINT",
        PRINT_OPTION_UPDATED: "PRINT_OPTION_UPDATED",
        DISABLE_SHARE: "DISABLE_SHARE"
    };

    export var Internal = {
        DISPATCHER_NAME: "SYSTEM_DISPATCHER"
    }

    export enum MessageType {
        Warning,
        Error,
        Confirmation,
        Info,
        Success,
        ConfirmUserChanges,
        YesNo
    };
}
export default SystemConstants;